












































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    pageDataType,
    projectPageDataType
} from "../types";
import axios from "axios";
import {
    pageData
} from "../store/pageData";
import {
    ADD_ANIMATION
} from "../store/mutations.names";

@Component({
    name: "ProjectConf",
})
export default class ProjectConf extends Vue {
    @Getter("pageData") public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Prop() public compData!: string | null;
    @Getter("projectList") public pages!: projectPageDataType[];
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;

    get projectData(): null | any {
        if (!this.pageData) {
            return null;
        }
        return {
            apartment_types: this.pageData.apartment_types,
            architect: this.pageData.architect,
            facing: this.pageData.facing,
            land_area: this.pageData.land_area,
            location: this.pageData.location,
            num_of_apartments: this.pageData.num_of_apartments,
            num_of_basements: this.pageData.num_of_basements,
            num_of_car_parking: this.pageData.num_of_car_parking,
            orientation_of_land: this.pageData.orientation_of_land,
            rajuk_approval_no: this.pageData.rajuk_approval_no,
            size_of_apartments: this.pageData.size_of_apartments
        };
    }
}
